export default {
  activateLandingPageTitle: 'S\u1ef1 ki\u1ec7n',
  activateProductCardTitle: 'S\u1ef1 ki\u1ec7n',
  activateProductPageTitle: '\u0110\u1eb7t s\u1ef1 ki\u1ec7n',
  allProductsLandingPageTitle:
    '\u0110\u1eb7t tr\u1ea3i nghi\u1ec7m \u0111\u1ed9c \u0111\u00e1o',
  apply: '\u00c1p d\u1ee5ng',
  buyTickets: 'Mua v\u00e9',
  cancel: 'H\u1ee7y',
  clear: 'X\u00f3a',
  clearFilters: 'X\u00f3a b\u1ed9 l\u1ecdc',
  discoverExperiences: 'Kh\u00e1m ph\u00e1 tr\u1ea3i nghi\u1ec7m',
  exclusive: '\u0110\u1ed9c quy\u1ec1n',
  experience: 'tr\u1ea3i nghi\u1ec7m',
  experiencePhotoOfListing:
    '\u1ea2nh tr\u1ea3i nghi\u1ec7m {{photoNumber}} c\u1ee7a danh m\u1ee5c {{listingTitle}}',
  experiences: 'tr\u1ea3i nghi\u1ec7m',
  filterExperiences: 'L\u1ecdc tr\u1ea3i nghi\u1ec7m',
  fromListingCard: 'T\u1eeb',
  hostedBy: 'T\u1ed5 ch\u1ee9c b\u1edfi',
  hostLandingPageTitle: 'Tr\u1ea3i nghi\u1ec7m \u0111\u1ecba ph\u01b0\u01a1ng',
  hostProductCardTitle: 'Tr\u1ea3i Nghi\u1ec7m \u0110\u1ecba Ph\u01b0\u01a1ng',
  hostProductPageTitle:
    '\u0110\u1eb7t tr\u1ea3i nghi\u1ec7m \u0111\u1ecba ph\u01b0\u01a1ng',
  landingPageTitle:
    '\u0110\u1eb7t tr\u1ea3i nghi\u1ec7m \u0111\u1ed9c \u0111\u00e1o',
  mainLandingPageTitle: 'T\u1ea5t c\u1ea3 tr\u1ea3i nghi\u1ec7m',
  more: 'Th\u00eam',
  noExperiencesFound: 'Kh\u00f4ng t\u00ecm th\u1ea5y tr\u1ea3i nghi\u1ec7m',
  noExperiencesFoundFor:
    'Kh\u00f4ng t\u00ecm th\u1ea5y tr\u1ea3i nghi\u1ec7m cho',
  experiencesFoundCount: 'T\u00ecm th\u1ea5y {{count}} tr\u1ea3i nghi\u1ec7m',
  profileImageOfHost:
    '\u1ea2nh \u0111\u1ea1i di\u1ec7n c\u1ee7a ng\u01b0\u1eddi t\u1ed5 ch\u1ee9c {{hostName}}',
  reserve: '\u0110\u1eb7t ch\u1ed7',
  reserveLandingPageTitle: 'Ho\u1ea1t \u0111\u1ed9ng & ti\u1ec7n nghi',
  reserveProductCardTitle: 'Ho\u1ea1t \u0111\u1ed9ng',
  reserveProductPageTitle:
    '\u0110\u1eb7t ho\u1ea1t \u0111\u1ed9ng & ti\u1ec7n nghi',
  resultsPageTitle:
    '\u0110\u1eb7t tr\u1ea3i nghi\u1ec7m & ho\u1ea1t \u0111\u1ed9ng',
};
